import Toy from "../../images/Toy.png";
import IndusMachine from "../../images/IndusMachine.png";

const questionAnswers = [
  // Toy Questtions
  // Domestic Graph Questions
  {
    title: "U.S. Toy Market",
    type: "domestic",
    answer: [1, 5],
    answerTextTop: "Q. Only U.S. suppliers are able to sell toys in the U.S.",
    answerText:
      "Total surplus includes both producer (i.e., suppliers) and consumer surplus. Producer surplus is the area above the supply curve and below the price. Consumer surplus is the area below the demand curve and above the price. Together, the entire area above the supply curve and below the demand curve represents total gains from trade, i.e., total surplus.",
    notQuiteText:
      "Not quite. You identified part, but not all of the total surplus from domestic trade.",
    header: "DOMESTIC TRADE ONLY",
    mobileHeader: "DOMESTIC TRADE ONLY",
    text: "Only U.S. suppliers are able to sell toys in the U.S.",
    question: "TOTAL SURPLUS",
    icon: Toy,
  },

  // International Graph Questions
  {
    title: "U.S. Toy Market",
    type: "international",
    answer: [2, 5, 6, 7, 8], //2A,2B,2C,2D,2E
    answerTextTop:
      "Q. The U.S. is now able to import toys from other countries at a lower price than the U.S. market price.",
    answerText:
      "Total surplus is the sum of consumer and producer surplus. It has expanded to the large shape shown.",
    notQuiteText:
      "Not quite. You identified part, but not all of the new total surplus from international trade.",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",
    text: "The U.S. is now able to import toys from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>”  on the graph.",
    question: "NEW TOTAL SURPLUS",
    icon: Toy,
  },
  {
    title: "U.S. Toy Market",
    type: "international",
    answer: [6, 7], //2C, 2D
    answerTextTop:
      "Q. The U.S. is now able to import toys from other countries at a lower price than the U.S. market price.",
    answerText:
      "The triangle shows all of the additional (net) gains of total surplus created by allowing trade to include international markets.",
    notQuiteText:
      "Not quite. You identified part, but not all of the net gains from international trade.",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",
    text: "The U.S. is now able to import toys from other countries at a lower price than the U.S. market price.",
    question: "GAINS FROM INTERNATIONAL TRADE",
    icon: Toy,
  },
  // (MC answer choices: a Domestic consumers, b Domestic producers, c. domestic consumer and domestic consumers, d. No One)
  {
    title: "U.S. Toy Market",
    type: "international",
    answer: ["A"], //Domestic consumers
    options: [
      "Domestic consumers",
      "Domestic producers",
      "All of the above",
      "No one",
    ],
    alreadySelect: [6, 7], //2C, 2D
    answerTextTop: "Q. Who received this surplus?",
    answerText:
      "<b>Domestic consumers</b> are the winners here. More consumers can now afford the toys at this lower price.",
    notQuiteText: "",
    header: "",
    mobileHeader: "",
    text: "Who received this surplus?",
    question: "",
    icon: Toy,
  },
  {
    title: "U.S. Toy Market",
    type: "international",
    answer: ["B"], //Domestic producers
    options: [
      "Domestic consumers",
      "Domestic producers",
      "All of the above",
      "No one",
    ],
    alreadySelect: [], //
    answerTextTop:
      "Q. Was there anyone who lost surplus when the U.S. moved from domestic only to international trade of toys?",
    answerText:
      "<b>Domestic producers</b> lose surplus, since they supply fewer toys at a lower price compared to when there were no imported toys.",
    notQuiteText: "",
    header: "",
    mobileHeader: "",
    text: "Was there anyone who lost surplus when the U.S. moved from domestic only to international trade of toys?",
    question: "",
    icon: Toy,
  },
  {
    title: "U.S. Toy Market",
    type: "international",
    answer: [5], //2B
    answerTextTop:
      "Q. Domestic producers lost as a result of moving from domestic only to international trade.",
    answerText:
      "Lost domestic producer surplus is simply the difference between producer surplus with and without international trade.",
    notQuiteText: "",
    header: "WITH INTERNATIONAL TRADE",
    mobileHeader: "INTERNATIONAL TRADE",
    text: "Domestic producers lost as a result of moving from domestic only to international trade.",
    question: "LOST DOMESTIC PRODUCER SURPLUS",
    icon: Toy,
  },
  // // a. Domestic consumers gained this surplus b. foreign consumers gained this surplus c. No one gained this surplus; it is deadweight loss of international trade
  {
    title: "U.S. Toy Market",
    type: "international",
    answer: ["A"], //Domestic consumers gained this surplus
    options: [
      "Domestic consumer surplus",
      "Foreign consumer surplus",
      "All of the above",
      "The deadweight loss of international trade",
    ],
    alreadySelect: [5], //2B
    answerTextTop:
      "Q. When the U.S. opens to international trade, this area that was producer surplus becomes:",
    answerText:
      "This area is now <b>domestic consumer</b> surplus. Domestic consumers enjoy lower prices on toys than what they would have paid with only domestic trade.",
    notQuiteText: "",
    header: "",
    mobileHeader: "",
    text: "When the U.S. opens to international trade, this area that was producer surplus becomes:",
    question: "",
    icon: Toy,
  },

  // Industrial Machine
  // Domestic
  {
    title: "U.S. Industrial Machine Market",
    type: "domestic",
    answer: [1, 5], //1A,1B
    answerTextTop:
      "Q. U.S. suppliers are able to sell industrial machines only in the U.S.",
    answerText:
      "Total surplus includes both producer (i.e., suppliers) and consumer surplus. Producer surplus is the area above the supply curve and below the price. Consumer surplus is the area below the demand curve and above the price. Together, the entire area above the supply curve and below the demand curve represents total gains from trade, i.e., total surplus.",
    notQuiteText:
      "Not quite. You identified part, but not all of the total surplus from domestic trade.",
    header: "DOMESTIC TRADE ONLY",
    mobileHeader: "DOMESTIC TRADE ONLY",
    text: "U.S. suppliers are able to sell industrial machines only in the U.S.",
    question: "TOTAL SURPLUS",
    icon: IndusMachine,
  },

  // international 2
  {
    title: "U.S. Industrial Machine Market",
    type: "international2",
    answer: [2, 4, 5, 6, 9, 10], //3A,3B,3C,3D,3E,3F
    answerTextTop:
      "Q. U.S. suppliers are now able to export industrial machines to other countries at a higher price than the domestic price.",
    answerText:
      "Total surplus is the sum of consumer and producer surplus. It has expanded to the large shape shown.",
    notQuiteText:
      "Not quite. You identified part, but not all of the new total surplus from international trade.",
    header: "WITH INTERNATIONAL TRADE",
    text: "U.S. suppliers are now able to export industrial machines to other countries at a higher price than the domestic price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
    question: "NEW TOTAL SURPLUS",
    icon: IndusMachine,
  },
  {
    title: "U.S. Industrial Machine Market",
    type: "international2",
    answer: [6], //3D
    answerTextTop:
      "Q. U.S. suppliers are now able to export industrial machines to other countries at a higher price than the domestic price.",
    answerText:
      "The triangle shows all of the additional (net) gains created by allowing trade to include international markets.",
    notQuiteText: "",
    header: "WITH INTERNATIONAL TRADE",
    text: "U.S. suppliers are now able to export industrial machines to other countries at a higher price than the domestic price.",
    question: "GAINS FROM INTERNATIONAL TRADE",
    icon: IndusMachine,
  },
  {
    title: "U.S. Industrial Machine Market",
    type: "international2",
    answer: ["B"], //Domestic producers
    options: [
      "Domestic consumers",
      "Domestic producers",
      "All of the above",
      "No one",
    ],
    alreadySelect: [6], //3D
    answerTextTop: "Q. Who received this surplus? ",
    answerText:
      "Here, the <b>U.S. suppliers</b> have a comparative advantage. Since the price has increased, domestic producers are the winners. They are now able to sell machines to foreign consumers at this higher price.",
    notQuiteText: "",
    header: "",
    mobileHeader: "",
    text: "Who received this surplus?",
    question: "",
    icon: IndusMachine,
  },
  {
    title: "U.S. Industrial Machine Market",
    type: "international2",
    answer: ["A"], //Domestic consumers
    options: [
      "Domestic consumers",
      "Domestic producers",
      "All of the above",
      "No one",
    ],
    alreadySelect: [], //
    answerTextTop:
      "Q. Was there anyone who lost surplus when the U.S. moved from domestic only to international trade of toys?",
    answerText:
      "Since the price increased, <b>domestic consumers</b> have lost surplus. They do not buy as much equipment as they did before the U.S. began trading internationally.",
    notQuiteText: "",
    header: "",
    mobileHeader: "",
    text: "Was there anyone who lost surplus when the U.S. moved from domestic only to international trade of toys?",
    question: "",
    icon: IndusMachine,
  },
  {
    title: "U.S. Industrial Machine Market",
    type: "international2",
    answer: [4, 5], //3B,3C
    answerTextTop:
      "Q. Domestic consumers lost surplus as a result of the U.S. moving from domestic only to international trade.",
    answerText:
      "Lost domestic consumer surplus is simply the difference between consumer surplus with and without international trade.",
    notQuiteText:
      "Not quite. You identified part, but not all of the domestic consumer losses from international trade.",
    header: "WITH INTERNATIONAL TRADE",
    text: "Domestic consumers lost surplus as a result of the U.S. moving from domestic only to international trade.",
    question: "LOST DOMESTIC CONSUMER SURPLUS",
    icon: IndusMachine,
  },
  {
    title: "U.S. Industrial Machine Market",
    type: "international2",
    answer: ["B"], //Domestic producers
    options: [
      "Foreign producer surplus",
      "Domestic producer surplus",
      "All of the above",
      "The deadweight loss of international trade",
    ],
    alreadySelect: [4, 5], //3B, 3C
    answerTextTop:
      "Q. When the U.S. opens to international trade, this area that was domestic consumer surplus becomes:",
    answerText:
      "Here, the <b>domestic producers</b> have a comparative advantage. They are now able to receive a higher price for each unit that they sell, resulting in increased producer surplus.",
    notQuiteText: "",
    header: "",
    mobileHeader: "",
    text: "When the U.S. opens to international trade, this area that was domestic consumer surplus becomes:",
    question: "",
    icon: IndusMachine,
  },
];

export default questionAnswers;
